export const apiPath = '/v2/tags';
const actionType = 'TAGS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
